/** Lógica pura del Historial de movimientos (Mati, 2026-10-18). Los textos los arma el backend; acá sólo el día, la
 * hora y el color de cada acción. */
import type { BadgeTono } from "@/components";
import type { MovimientoHistorial } from "./api";
import { formatFechaLocal } from "./format";

/** "14:05" en la zona del que mira (como `formatFechaLocal`). */
export function formatHora(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}

/** "18/10/2026 14:05" */
export const formatCuando = (iso: string): string => `${formatFechaLocal(iso)} ${formatHora(iso)}`;

export const ETIQUETA_ACCION: Record<string, string> = { crear: "Alta", editar: "Edición", borrar: "Baja", descargar: "Descarga" };
export const TONO_ACCION: Record<string, BadgeTono> = { crear: "exito", editar: "primario", borrar: "peligro", descargar: "neutro" };

export const etiquetaAccion = (m: MovimientoHistorial): string => (m.deshace_id !== null ? "Deshacer" : (ETIQUETA_ACCION[m.accion] ?? m.accion));
export const tonoAccion = (m: MovimientoHistorial): BadgeTono => (m.deshace_id !== null ? "alerta" : (TONO_ACCION[m.accion] ?? "neutro"));

/** "2026-09-01" → "01/09/2026"; el resto tal cual; null → "—". Para los campos de una edición. */
export function formatValorCambio(valor: string | null): string {
  if (valor === null || valor === "") return "—";
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(valor);
  return m ? `${m[3]}/${m[2]}/${m[1]}` : valor;
}

/** Junta páginas sin repetir (por si una recarga se cruza con "Ver más"). */
export function juntarPaginas(actuales: MovimientoHistorial[], nuevas: MovimientoHistorial[]): MovimientoHistorial[] {
  const vistos = new Set(actuales.map((m) => m.id));
  return [...actuales, ...nuevas.filter((m) => !vistos.has(m.id))];
}
